import { useTheme } from '@hooks/useTheme';

export const useOutlineRing = (): ((str?: string) => string) => {
  const { colors } = useTheme();
  return (colorStr?: string): string => {
    return `5px auto ${colorStr || colors.primary} !important`;
  };
};
